import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

import { IS_DEV } from '../constants/app-config';
import reducers from '../reducers';
import { persistConfig } from './config';

export function getStore() {
  const middlewares = [thunk];

  let composeEnhancer = compose;

  if (IS_DEV) {
    middlewares.push(
      createLogger({
        diff: true,
        collapsed: (getState, action, logEntry) => !logEntry.error,
      }),
    );
  }

  const persistedReducer = persistReducer(persistConfig, reducers);
  const store = createStore(
    persistedReducer,
    composeEnhancer(applyMiddleware(...middlewares)),
  );
  const persistor = persistStore(store);

  return { store, persistor };
}
